/** Discover → Skills (AUTO-8). Thin wrapper around <CatalogBrowsePage>. */

import { createFileRoute } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/skills')({
  component: DiscoverSkillsPage,
});

function DiscoverSkillsPage() {
  return (
    <CatalogBrowsePage
      kind="skill"
      title="Skills"
      description="Reusable instruction bundles that compose tools + functions into a named capability. Tenant skills live in Studio → Skills; this is the system-wide catalog."
      icon={Sparkles}
    />
  );
}
